<script setup>
import { ref, onMounted } from 'vue'
import QRCode from 'qrcode'
const qrCodeDataUrl = ref('')

onMounted(async () => {
  const fullUrl = window.location.origin + '/#/documents'
  qrCodeDataUrl.value = await QRCode.toDataURL(fullUrl)
})
</script>
<template>
    <div>
      <div v-if="qrCodeDataUrl">
        <img :src="qrCodeDataUrl" alt="QR Code"  />
      </div>
    </div>
</template>